import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../models/state/app-state";
import { SessionsSettingsApiService } from "../../services/api-services/sessions-settings/sessions-settings.api-service";
import { ListFeatureAction } from "./list-features.actions";
import { selectArea } from "./list-features.selectors";
import { switchMap, take, map, mergeMap, catchError, EMPTY } from "rxjs";



@Injectable()
export class ListFeatureEffects {
  actions$: Actions = inject(Actions);
  store: Store = inject(Store);
  sessionSettings: SessionsSettingsApiService = inject(SessionsSettingsApiService);

  updateHeaderSizeSaveToDBEffect1$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ListFeatureAction.saveListStateToDb),
      switchMap((action) => {
        return this.store.pipe(
          select(selectArea(action.area)),
          take(1), // Take only the first occurrence
          map((currentState) => ({ currentState, area: action.area })));
      }
      ),
      mergeMap((currentStateArea) => {
        const currentState = currentStateArea.currentState;
        // if (currentStateArea == undefined || currentStateArea.area == undefined) {
        //   return EMPTY;
        // }

        // const currentListState = []
        // if (currentState?.features?.filters != undefined) {

        //   currentListState.push({ type: "filters", filters: currentState.features.filters });
        // }
        // if (currentState?.features?.sortings != undefined) {
        //   currentListState.push({ type: "sortings", Sortings: currentState.features.sortings });
        // }
        // if (currentState?.features?.selectedColumns != undefined) {
        //   currentListState.push({
        //     type: "selectedColumns",
        //     selectedColumns: currentState.features.selectedColumns
        //   });
        // }
        // if (currentState?.columnSizes != undefined) {
        //   currentListState.push({ type: "columnSizes", columnSizes: currentState.columnSizes });
        // }
        // if (currentState?.isCardView != undefined) {
        //   currentListState.push({ type: "isCardView", isCardView: currentState.isCardView });
        // }
        // if (currentState?.listTableFunctions != undefined) {

        //   const listTableFunctions = currentState.listTableFunctions.map(listFunction => ({
        //     key: listFunction.key,
        //     action: listFunction.action,
        //     isVisible: listFunction.isVisible
        //   }));

        //   currentListState.push({ type: "listTableActions", listTableActions: listTableFunctions });
        // }

        // if (currentState?.listHeaders != undefined) {

        //   const listHeaders = currentState.listHeaders.map(header => ({
        //     key: header.key,
        //     isSortAssending: header.isSortAscending,
        //     isSortActive: header.isSortActive,
        //     isDefault: header.isDefault,
        //     isVisible: header.isVisible
        //   }));

        //   currentListState.push({ type: "listHeaders", listHeaders: listHeaders });
        // }

        return this.sessionSettings.saveUserSettingsGenPayload(currentStateArea.area, 'currentState', currentState).pipe(
          map((result) => {
            // Dispatch success action if needed
            return { type: 'Effect_Saved', payload: result };
          }),
          catchError((err) => {
            // Dispatch failure action if needed
            return EMPTY; // or any other observable
          })
        )
      })
    );
  },
    { dispatch: true } // Set dispatch to true if you want to dispatch actions from this effect
  );


}
